import React from 'react';

// import FilterData from '../../../../../components/FilterAnalyze/FilterData/FilterData';
import OrgBotsNumberReport from './Components/Reports/OrgBotsNumberReport';
// import OrgBotsNumberGraphic from './Components/Graphics/OrgBotsNumberGraphic';

/**
 * Component for showing the org bots number report components
 *
 * @param {*} { parentFilter, onClickFilter }
 * @returns
 */
const OrgBotsNumber = ({ parentFilter, onClickFilter }) => {
  return (
    <div>
      {/* <FilterData onClickFilter={onClickFilter} /> */}
      <OrgBotsNumberReport componentData={{ parentFilter }} />
      {/* <OrgBotsNumberGraphic componentData={{ parentFilter }} /> */}
    </div>
  );
};

export default OrgBotsNumber;
